import { commonViewTexts } from '../common';

export const companyRootViewTexts = {
  tabLabels: {
    projectList: `${commonViewTexts.project}一覧`,
    modelList: `${commonViewTexts.model}一覧`
  }
} as const;
